import styles from './downloadRetentionCertificatePDFModal.module.css'
import { useEffect, useState } from "react"
import { PaymentOrder } from '../../../state/types'
import { fileHelpers, usePDFActions } from '../../../../../features/files'
import { FileTile, FileType, Modal, ModalId } from '../../../../../features/ui'
import { RetentionCertificatePDF } from '../retention-certificate-pdf/retentionCertificatePDF'

type Props = {
    paymentOrder?: PaymentOrder
}

export const DownloadRetentionCertificatePDFModal = (props: Props) => {
    const { paymentOrder } = props

    const [pdfName, setPdfName] = useState<string>()

    const { retentionCertificateFileName } = fileHelpers

    const { generatePDF, printPDF, isPrinting } = usePDFActions()

    useEffect(() => {
        paymentOrder && setPdfName(retentionCertificateFileName(paymentOrder.code))
    }, [paymentOrder])

    const pdfId = 'retention-certificate-pdf'

    const onSubmit = () => {
        pdfName && generatePDF(pdfId, pdfName)
    }

    const renderHiddenPDF = () => paymentOrder ? (
        <div className={styles.hidden}>
            <RetentionCertificatePDF
                id={pdfId}
                paymentOrder={paymentOrder}
            />
        </div>
    ) : <></>

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_RETENTION_CERTIFICATE_PDF}
            title="Descargar Certificado de Retención"
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
            secondaryLabel="Imprimir"
            secondaryIcon="printer"
            disableSecondary={isPrinting || !pdfName}
            onSecondarySubmit={() => printPDF(pdfId)}
        >
            <FileTile fileType={FileType.PDF} fileName={pdfName}/>
            {renderHiddenPDF()}
        </Modal>
    )
}
